import React from 'react';
import {
  Container, Typography, Box, Button,
} from '@mui/material';
import StyledBox from 'views/rebranded-module/HomeViewV2/components/UI/VideoCalloutSection/VideoCalloutSection.styles';

import { Typography700 } from 'views/common/components';
import PATHS from 'lib/navigation/paths';
import NavigatorLink from 'views/rebranded-module/common/components/Logical/NavigatorLink';
import { Video } from 'views/rebranded-module/common/components';
import { useContent } from 'views/rebranded-module/common/context/useContent';

const VideoCalloutSection = () => {
  const content = useContent('HomePage');

  return (
    <StyledBox>
      <Box className="VCSOverlay" />
      <Video
        className="HSVideo"
        videoSrc={content.videoCalloutSectionVideo?.url}
        fallbackImg={{
          src: content.videoCalloutSectionVideoFallbackImage?.url,
          alt: content.videoCalloutSectionVideoFallbackImage?.alt,
          width: '100%',
          height: '100%',
        }}
      />

      <Container maxWidth="xl">
        <Box className="VSSContent">
          <Typography700 variant="h3" component="h3" className="VCSTextTitle">
            {content.videoCalloutSectionTitle}
          </Typography700>
          <Typography variant="bodyXL" className="VCSTextDes">
            {content.videoCalloutSectionDescription}
          </Typography>
          <Button
            component={NavigatorLink}
            className="VSCTextBtn"
            variant="contained"
            href={PATHS.motorcycleTours.index(
              {
                ref: 'homepage',
              },
              'iconic-rides-section',
            )}>
            {content.videoCalloutSectionButtonText}
          </Button>
        </Box>
      </Container>
    </StyledBox>
  );
};
export { VideoCalloutSection };
